import React, { useState } from "react";

import CheckIcon from "@material-ui/icons/Check";
import LaunchIcon from "@mui/icons-material/Launch";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

import { GreyDark } from "assets/colors";

import { IMenuOptions } from "./MoreActionsMenu";

export interface ICustomMoreSubOptionsMenuProps {
  option: IMenuOptions;
  selectedItems?: any[];
  onSelectDeselectOption?: (
    value: string | undefined,
    checked: boolean,
  ) => void;
  onClose: () => void;
  onAction?: (action: (id?: string) => void) => void;
  icon?: any;
  isHelpButton?: boolean;
}

export const MoreActionsSubMenu: React.FC<ICustomMoreSubOptionsMenuProps> = ({
  option,
  selectedItems,
  onAction,
  onSelectDeselectOption,
  onClose,
  icon,
  isHelpButton,
}) => {
  const [subMenuAnchorEl, setSubMenuAnchorEl] = useState<null | HTMLElement>(
    null,
  );
  const [selectedOption, setSelectedOption] = useState<IMenuOptions | null>(
    null,
  );

  const handleClose = () => {
    setSubMenuAnchorEl(null);
    setSelectedOption(null);
    onClose();
  };

  const handleSelect =
    (option: IMenuOptions) => (event: React.MouseEvent<HTMLElement>) => {
      if (option.subOptions) {
        setSelectedOption(option);
        setSubMenuAnchorEl(event.currentTarget);
      } else {
        setSubMenuAnchorEl(null);
        if (option.hasOwnProperty("checked") && onSelectDeselectOption) {
          onSelectDeselectOption(option.value, !option.checked);
        }
        if (option.hasOwnProperty("action")) {
          if (onAction) {
            onAction(option.action);
          } else {
            option.action();
          }
        }

        handleClose();
      }
    };

  return (
    <div>
      <MenuItem
        key={`option.label-${option.label}`}
        style={{
          ...(option?.subOptions && { paddingLeft: "2px" }),
        }}
        onClick={handleSelect(option)}
        disabled={
          option.disabled
            ? option.disabled(selectedItems ?? [], option.additionnalInfos)
            : false
        }
      >
        {option?.subOptions && (
          <span
            className="material-icons-outlined"
            style={{ fontWeight: 400, color: GreyDark }}
          >
            {`keyboard_arrow_left`}
          </span>
        )}

        {option.checked && <CheckIcon aria-label="CheckIcon" />}

        {isHelpButton && (
          <LaunchIcon style={{ fontSize: "1rem", margin: "5px" }} />
        )}

        {icon &&
        (icon.props["aria-label"] === "AccountCircle" || icon.props.src) ? (
          <strong>{option.label}</strong>
        ) : (
          option.label
        )}
      </MenuItem>

      <Menu
        anchorEl={subMenuAnchorEl}
        open={Boolean(subMenuAnchorEl)}
        onClose={onClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "top" }}
        MenuListProps={{
          onMouseLeave: () => {
            setSubMenuAnchorEl(null);
          },
        }}
      >
        {selectedOption?.subOptions?.map((subOption) => (
          <MoreActionsSubMenu
            key={`option.label-${subOption.label}`}
            option={subOption}
            selectedItems={selectedItems}
            onAction={onAction}
            onSelectDeselectOption={onSelectDeselectOption}
            onClose={handleClose}
          />
        ))}
      </Menu>
    </div>
  );
};

export default MoreActionsSubMenu;
